import { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import MKTypography from "components/MKTypography";
import api from "services/api";
import { useTranslation } from "react-i18next";
import SignedDownloadButton from "./SignedDownloadButton";

function LinuxDesc() {
  const { t } = useTranslation();
  const [software, setSoftware] = useState(null);
  const downloads = software?.items || [];

  useEffect(() => {
    api
      .get("/software/linux/")
      .then((res) => {
        setSoftware(res?.data || null);
      })
      .catch(() => {
        setSoftware(null);
      });
  }, []);

  const getDescriptionKey = (arch) => {
    if (arch === "amd64") return "clients.linux.downloads.amd64";
    if (arch === "arm64") return "clients.linux.downloads.arm64";
    return "";
  };

  const getLabel = (download) => {
    if (download.arch === "amd64") return "Linux x86_64 / amd64";
    if (download.arch === "arm64") return "Linux arm64";
    return download.arch ? `Linux ${download.arch}` : download.name;
  };

  return (
    <Card
      sx={{
        p: { xs: 2, md: 3 },
        mx: { xs: 2, lg: 3 },
        mt: 2,
        mb: 2,
        boxShadow: ({ boxShadows: { lg } }) => lg,
      }}
    >
      <MKTypography variant="h5" fontWeight="bold" mb={1}>
        {t("clients.linux.desc.title")}
      </MKTypography>
      <MKTypography variant="body2" color="text" mb={2}>
        {t("clients.linux.desc.intro")}
      </MKTypography>
      <Grid container spacing={2}>
        {downloads.map((download) => {
          const descriptionKey = getDescriptionKey(download.arch);
          return (
            <Grid key={download.slug || download.arch} item xs={12} md={6}>
              <Stack
                spacing={1}
                sx={{
                  height: "100%",
                  border: "1px solid",
                  borderColor: "grey.300",
                  borderRadius: 1,
                  p: 2,
                }}
              >
                <MKTypography variant="h6" fontWeight="bold">
                  {getLabel(download)}
                </MKTypography>
                <MKTypography variant="body2" color="text">
                  {descriptionKey ? t(descriptionKey) : download.supported_models}
                </MKTypography>
                <Stack direction="row" sx={{ alignSelf: "flex-start" }}>
                  <SignedDownloadButton
                    linkUrl={download.signed_link_url}
                    label={t("clients.common.download")}
                  />
                </Stack>
              </Stack>
            </Grid>
          );
        })}
      </Grid>
    </Card>
  );
}

export default LinuxDesc;
